import axios from 'axios';

const getInitialState = function () {
  var state = {
    notifications: localStorage.getItem('rpc-notifications') ? JSON.parse(localStorage.getItem('rpc-notifications')) : [],
  };
  return state;
};

export default {
  namespaced: true,

  state: getInitialState(),

  getters: {
    getNotifications(state) {
      return state.notifications;
    },
    getNotificationsCount(state) {
      return state.notifications.length;
    },
  },

  mutations: {
    addNotification(state, payload) {
      let exists = state.notifications.find(n => n.payload_id == payload.payload_id);
      if (!exists) {
        state.notifications.push(payload);
      }
    },
    removeNotification(state, index) {
      axios.delete('/auth/notification-payloads/' + state.notifications[index]['payload_id']);
      state.notifications.splice(index, 1);
    },
    clearAllNotifications(state) {
      axios.delete('/auth/notification-payloads');
      state.notifications.splice(0);
    },
    RESET_STATE:function (state) {
      Object.assign(state, getInitialState())
    }
  },

  actions: {
    addNotification(context, payload) {
      context.commit('addNotification', payload);
    },
    removeNotification(context, payload) {
      context.commit('removeNotification', payload);
    },
    clearAllNotifications(context, payload) {
      context.commit('clearAllNotifications', payload);
    },
  },
};
